import { createSlice } from '@reduxjs/toolkit'
import { userApi } from 'state/services/user/user'
import {
  accessTokenLocalStorageKey,
  initialWalletLoginLocalStorageKey,
  User,
  userIdLocalStorageKey
} from '@mprolab/sdk'
import { getUserAuthData } from './actions'

export interface UserState {
  userId: string | undefined
  accessToken: string | undefined
  isUserVerified: boolean
  user: User | null
  awaitingPath: string
  loadingUserData: boolean
}

export const initialState: UserState = {
  userId: undefined,
  accessToken: undefined,
  isUserVerified: true,
  user: {
    id: '',
    userId: '',
    createdAt: '',
    updatedAt: '',
    role: '',
    addresses: [
      {
        wallet: '',
        userId: '',
        createdAt: '',
        updatedAt: ''
      }
    ],
    socialMedia: [],
    personalDetails: {
      userId: '',
      username: '',
      email: '',
      avatar: '',
      createdAt: '',
      updatedAt: '',
      banner: '',
      bio: ''
    },
    activities: []
  },
  awaitingPath: '',
  loadingUserData: true
}

export const userSlice = createSlice({
  name: 'user',
  initialState,
  reducers: {
    clearUserData: (state) => {
      state.user = null
      state.isUserVerified = false
      state.loadingUserData = false
    },
    setAwaitingPath: (state, { payload }) => {
      state.awaitingPath = payload
    },
    setLoadingUserData: (state, { payload }) => {
      state.loadingUserData = payload
    }
  },
  extraReducers: (builder) => {
    builder.addCase(getUserAuthData.fulfilled, (state, { payload }) => {
      state.isUserVerified = payload.isUserVerified
      state.accessToken = payload.accessToken
      state.userId = payload.userId
      state.loadingUserData = false
    })
    builder.addCase(getUserAuthData.rejected, (state) => {
      localStorage.removeItem(userIdLocalStorageKey)
      localStorage.removeItem(accessTokenLocalStorageKey)
      localStorage.removeItem(initialWalletLoginLocalStorageKey)
      state.isUserVerified = false
      state.accessToken = undefined
      state.userId = undefined
      state.loadingUserData = false
    })
    builder.addMatcher(userApi.endpoints.me.matchFulfilled, (state, { payload }) => {
      const localUserId = localStorage.getItem(userIdLocalStorageKey)
      const localAccessToken = localStorage.getItem(accessTokenLocalStorageKey)
      state.accessToken = localAccessToken
      state.userId = localUserId
      state.user = payload
      state.isUserVerified = true
      state.loadingUserData = false
    })
    builder.addMatcher(userApi.endpoints.me.matchRejected, (state) => {
      state.isUserVerified = false
      state.loadingUserData = false
    })
  }
})

export default userSlice.reducer
